import { Select } from "@enxcs/dap-ui-stratos";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface RecordingLanguageSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

const RecordingLanguageOptions = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "Nederlands",
    value: "nl",
  },
  {
    label: "Français",
    value: "fr",
  },
  {
    label: "Deutsch",
    value: "de",
  },
];

export const RecordingLanguageSelect: FC<RecordingLanguageSelectProps> = ({ value, onChange, label }) => {
  const { t } = useTranslation();

  return (
    <Select
      data-qa-id="new-recording-select-language"
      label={label ?? t("newRecordingModal.language")}
      value={value}
      onChange={onChange}
      options={RecordingLanguageOptions}
    />
  );
};
